import React, { useEffect, useRef } from "react";
import Footer from "../Footer";
import HealthcareStory from "./HealthcareStory";
import OurLeaders from "./OurLeaders";
import Header from "../Header";

const AboutUs = () => {
  return (
    <>
      <Header/>
      <HealthcareStory/>
      <OurLeaders/>

      <Footer/>
      
      
    </>
  );
};

export default AboutUs;